import * as React from 'react';
import { ICON_SIZE_MAP } from '../helpers/size.js';
const SparklesIcon = React.forwardRef((props, ref) => {
    const sizeKey = props.size !== undefined ? props.size : 1;
    const size = ICON_SIZE_MAP[sizeKey];
    return (React.createElement("svg", { width: size, height: size, fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: ref, viewBox: "0 0 16 16" },
        React.createElement("path", { d: "M12.47 5.78a.75.75 0 0 0 1.28-.53 1.5 1.5 0 0 1 1.5-1.5.75.75 0 1 0 0-1.5 1.5 1.5 0 0 1-1.5-1.5.75.75 0 1 0-1.5 0 1.5 1.5 0 0 1-1.5 1.5.75.75 0 1 0 0 1.5 1.5 1.5 0 0 1 1.5 1.5c0 .199.079.39.22.53ZM5.293 15.707A1 1 0 0 0 7 15a4 4 0 0 1 4-4 1 1 0 0 0 0-2 4 4 0 0 1-4-4 1 1 0 0 0-2 0 4 4 0 0 1-4 4 1 1 0 0 0 0 2 4 4 0 0 1 4 4 1 1 0 0 0 .293.707Z", fill: "currentColor" })));
});
SparklesIcon.displayName = 'SparklesIcon';
export default SparklesIcon;
